import { render, staticRenderFns } from "./RegSetUser.vue?vue&type=template&id=fb99a46c&scoped=true"
import script from "./RegSetUser.vue?vue&type=script&lang=js"
export * from "./RegSetUser.vue?vue&type=script&lang=js"
import style0 from "./RegSetUser.vue?vue&type=style&index=0&id=fb99a46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb99a46c",
  null
  
)

export default component.exports